import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import InstrumentSubTypeLookup from '../Models/Lookups/InstrumentSubTypeLookup';
import InstrumentTypeLookup from '../Models/Lookups/InstrumentTypeLookup';

@NeoModel
export default class ManageInstrumentTypeComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
    }

    public managedInstrumentType = new InstrumentTypeLookup();
    public managedInstrumentSubtype = new InstrumentSubTypeLookup();
    public instrumentTypeName: string = "";

    public async initialise() {

    }
}